const TIME_REGEX = /^([0-2][0-9]):([0-5][0-9])$/;

/**
 * 時間文字列をDateオブジェクトに変換する
 * @param timeStr 時間文字列(hh:mm)
 * @returns Date
 */
export const parseTimeStringToDate = (timeStr: string): Date | null => {
  const match = timeStr.match(TIME_REGEX);
  if (!match) return null;

  const hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);

  const date = new Date();

  if (hours >= 24) {
    // 24時間を超える場合は日付を進める
    const daysToAdd = Math.floor(hours / 24);
    const remainingHours = hours % 24;
    date.setDate(date.getDate() + daysToAdd);
    date.setHours(remainingHours, minutes, 0, 0);
  } else {
    date.setHours(hours, minutes, 0, 0);
  }

  return date;
};
